import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { Router } from '@angular/router';
import { AuthService } from '../services/user-services/auth.service';
import { User } from 'oidc-client';
import { UserIdentity } from 'src/app/models/user-identity';
import {SignalrService} from '../services/signalr.service';


@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: []
})
export class AppLayoutComponent implements OnInit, OnDestroy {
  @ViewChild(HeaderComponent) header: HeaderComponent;

  sideMenuStatus = true;
  userIsLogged: boolean;
  userModel: Partial<UserIdentity> = {
    id: 0,
    roleName: '',
    userName: '',
    email: ''
  };
  avatarContent: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private signalr: SignalrService
  ) { }

  ngOnInit(): void {
    this.userIsLogged = false;
    this.authService.isLoggedIn().then(res => {
      if (res) {
        this.userIsLogged = true;
        this.setUserModelFromUser(this.authService.user);
        this.signalr.startConnection();
        this.signalr.addRevokeSessionListener();
      } else {
        this.authService.silentLoginEmitter.subscribe((user: User) => {
          this.setUserModelFromUser(user);
        });
      }
    });
  }

  setUserModelFromUser(user: User) {
    this.userModel.userName = user.profile?.name;
    this.userModel.roleName = user.profile?.role;
    this.avatarContent = this.getAvatarContent(user.profile?.name);
    this.userModel.email = user.profile?.email;
  }

  getAvatarContent(username: string): string {
    const usernameArray = username.split(' ');
    if (usernameArray.length === 1) {
      return usernameArray[0].split('')[0].toUpperCase();
    }
    if (usernameArray.length > 1) {
      const firstChar = usernameArray[0].split('')[0];
      const secondChar = usernameArray[1].split('')[0];
      return `${firstChar}${secondChar}`.toUpperCase();
    }
  }

  checkUserLoggedClass() {
    return this.userIsLogged ? 'user-logged' : 'user-anonymous';
  }
  checkUserRole() {
    return this.userModel.roleName === 'CedLabAdmin';
  }
  userLoggedRoutes() {
    return this.router.url.indexOf('/menu/') > -1;
  }
  signIn() {
    this.authService.login().then();
  }
  signOut() {
    this.authService.logout().then();
  }

  toggleSideMenu() {
    this.sideMenuStatus = !this.sideMenuStatus;
  }

  onResize(event) {
    const width = event.target.innerWidth;
    this.sideMenuStatus = width >= 1200;
  }

  ngOnDestroy(): void {
    this.authService.stopSilentRenew();
    this.signalr.stopConnection();
  }
}
